import { render, staticRenderFns } from "./ShowMoreInfoIcon.vue?vue&type=template&id=201f5c7c&scoped=true"
import script from "./ShowMoreInfoIcon.vue?vue&type=script&lang=js"
export * from "./ShowMoreInfoIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201f5c7c",
  null
  
)

export default component.exports